/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NotificationText.vue?vue&type=template&id=3838334b"
import script from "./NotificationText.vue?vue&type=script&lang=js"
export * from "./NotificationText.vue?vue&type=script&lang=js"
import style0 from "./NotificationText.vue?vue&type=style&index=0&id=3838334b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports